<template>
  <div class="mt-2">
    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbytimeOptions && !loading">
            <apexchart
              ref="reportuserbytime"
              type="area"
              height="350"
              :options="reportuserbytimeOptions"
              :series="reportuserbytimeSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import dayjs from 'dayjs'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },

  props: ['value', 'date', 'beaconSelect'],
  data() {
    return {
      loading: true,
      reportuserbytimeSeries: null,
      reportuserbytimeOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: this.$t('Message')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const vm = this
      try {
        vm.loading = true
        const response = await beaconApi.getReportUserByTimeBeaconsList({
          config: {
            pageid: vm.selectedBot.pageid,
            params: {
              from_date: dayjs(vm.date.start).format('YYYY-MM-DD'),
              to_date: dayjs(vm.date.end).format('YYYY-MM-DD')
            }
          }
        })
        handleResponse(response)

        await vm.$nextTick()
        let data = []
        let raw = []
        if (vm.beaconSelect) {
          raw = response.result.filter((item) => item.hwid === vm.beaconSelect.beacon_id)[0]
        }
        if (typeof raw === 'undefined') {
          vm.loading = false
          vm.reportuserbytimeSeries = [
            { name: vm.$t('Information received over time'), data: data }
          ]
        } else {
          let today = dayjs()

          for (let index = 0; index <= 23; index++) {
            const element = raw[`time_${index}`]
            let date = today.format(`YYYY-MM-DDT${index.toString()}:00`)
            // const tzOffset = new Date().getTimezoneOffset()
            data.push([dayjs(date).utcOffset(0, true).valueOf(), parseInt(element)])
          }

          vm.reportuserbytimeSeries = [
            { name: vm.$t('Information received over time'), data: data }
          ]
          let max = 0
          if (data && data.length > 0) {
            max = data.reduce((acc, val) => {
              acc = acc === undefined || val[1] > acc ? val[1] : acc
              return acc
            }, [])
          }

          if (vm.$refs.reportuserbytime) {
            vm.$refs.reportuserbytime.updateOptions({
              yaxis: {
                max: max + 5
              }
            })
          }
          vm.$emit('onLoaded', { loading: false, data: vm.reportuserbytimeSeries })
          vm.loading = false
        }
      } catch (error) {
        vm.loading = false
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/ReportUserByTime.vue